<template>
  <ApprovalDetail :back-link="$currentModule.getRoute('my-approvals')" />
</template>

<script>
import ApprovalDetail from '@modules/my-approval/views/detail'

export default {
  name: 'MyApprovalDetail',
  components: { ApprovalDetail },
}
</script>
